import { requestBuilder } from '../../http/RequestBuilder';
import type {
    AccountDetail,
    AccountType,
    Disclosure,
    HolisticCategory,
} from '../types/BankAccount';

interface CreateSavingsSpaceBody {
    userId: string;
    accountType: AccountType;
    holisticCategory?: HolisticCategory;
    jointEmail?: string;
    enableAutoPay?: boolean;
    linkedAccountId?: string;
    nickname?: string;
    icon?: string;
    color?: string;
    disclosures?: Disclosure[]; // Optional because KYC flow submits disclosures as well
}

const useCreateSpace = requestBuilder.mutation<
    AccountDetail,
    CreateSavingsSpaceBody
>({
    endpoint: '/api/bank-accounts',
    method: 'POST',
});

export default useCreateSpace;
